// Known ticker symbols that represent cash and should be mapped to CASH_USD.
// Symbols are stored uppercase and mirror engagebutton/cash_symbols.py.
export const CASH_USD_SYMBOLS = new Set([
  'FDIC.CASH',
  'USD_CASH',
  'USDCASH',
  '*$$$',
  '$CASH',
  'PERSHCASH',
  'SCHWABCASH',
  'FID:CASH',
  'CCY-GBP',
  'CASH:SWEEP',
  'RSK_CASH',
  'CUSTODIAL_CASH',
  'FCASH',
  'CASH$',
  'CASH-EQ',
  'CUR-AUD',
  'OT-CASH',
  'USDCURNCY',
  'INSUREDCASH',
  'CASHRESERVE',
  'CASH RESERVE',
  'CASH_USD',
  'USD CASH',
]);

export const COLORS = {
  neutral: {
    3: '#F6F7F8',
    7: '#FFFFFF',
  },
  primary: {
    3: '#805EE6',
    4: '#CABAF7',
    5: '#E3DAFB',
  },
  gray: {
    2: '#79849A',
    4: '#D0D4DC',
    5: '#E2E4E9',
  },
  accent: {
    blue: {
    },
    green: {
      3: '#3FA25C',
    },
    yellow: {
    },
    red: {
    },
  },
  assorted: [
    // When you need a group of colors but the exact colors are not important
    '#E3BB52', // Maize (Yellow Orange)
    '#52AFE3', // Turquoise (Blue with a bit of green)
    '#DF79C3', // Magenta
    '#8CD17B', // Pistachio (Light green with a bit of yellow)
    '#5ED5A3', // Aquamarine (Green with a bit of blue)
    '#E06E6E', // Salmon (Pink)
    '#B067E8', // Amethyst (Purple)
  ],
};
